import React, { useReducer, useEffect, useState, useRef } from "react";
import formReducer from "../../shared/forms/formReducer";
import { Button } from "primereact/button";
import FieldInputNumeroPhone from "../../shared/controls/customInputs/fieldInputPhone";
import FieldCalendar from "../../shared/controls/fieldCalendar";
import FieldDropDown from "../../shared/controls/fieldDropDown";
import alerts from "../../shared/alerts";
import useApiEmpleados from "../../api/catalogos/useApiEmpleados";
import permValidacionEsquema from "./permValidacionEsquema";
import useSeguridad from "../../Seguridad/useSeguridad";
import constantes from "../constantes";
import FieldInputNumeroRfc from "../../shared/controls/customInputs/fieldInputRfc";
import FieldTextBox from "../../shared/controls/fieldTextBox";

const AgendaNuevo = ({ onSave, close }) => {
    
    const seguridad = useSeguridad();
    const api = useApiEmpleados();
    const hasLoaded = useRef(false); 
    const [validationErrors, setValidationErrors] = useState({});

    const defaultEmpleado = () => ({
        entity: {
            datosGenerales: {
                nombre: '',
                apellidoPaterno: '',
                apellidoMaterno: '',
                rfc: '',
                telefonoPersonal: '',
                telefonoABC: '',
            },
            familiares: [],
            antidoping: [],
            actasAdministrativas: [],
            historial: [],
            licencias: [],
            archivosAdicionales: [],
            nomina: {
                SueldoBaseLiquidacion: seguridad.tieneAcceso(constantes.opciones.SueldoBaseLiquidacion),
                SueldoBaseStaff: seguridad.tieneAcceso(constantes.opciones.SueldoBaseStaff),
                SueldoBaseOficina: seguridad.tieneAcceso(constantes.opciones.SueldoBaseOficina),
            },
            recursosConfiables: [],
            empleadoBitacoras: []
        }
    });

    const [{ entity, errors }, dispatch] = useReducer(formReducer, {}, defaultEmpleado);
    const validateRfc = require('validate-rfc');
    
    useEffect(() => {

        if (hasLoaded.current) return; // Si ya se ejecutó, no hacer nada        
        hasLoaded.current = true; // Marcar como ejecutado

        const loadEmpleado = async () => {
            let empleado = { entity: await api.obtener(0) };

            if (empleado.entity.datosPersonales.estado == null)
                empleado.entity.datosPersonales.estado = empleado.entity.datosPersonales?.estados?.nombre ?? 'NA';

            if (empleado.entity.datosPersonales.municipio == null)
                empleado.entity.datosPersonales.municipio = empleado.entity.datosPersonales?.municipios?.nombre ?? 'NA';
            
            //valores default para permisionarios
            empleado.entity.asignacion.departamento.id = constantes.permisionarios.departamentoId;
            empleado.entity.asignacion.puesto.id = constantes.permisionarios.puestoId;
            empleado.entity.asignacion.tipoEmpleado.id = constantes.permisionarios.tipoEmpleadoId;
            empleado.entity.asignacion.jefeInmediato.id = constantes.permisionarios.jefeInmediatoId;
            empleado.entity.asignacion.unidadNegocio = { id: 0, nombre: '' };
            
            const hoy = new Date();
            const unAnioDespues = new Date(hoy);
            unAnioDespues.setFullYear(hoy.getFullYear() + 1);
            
            empleado.entity.licencias = [{
                categoriaLicencia: { id: 0, nombre: '' },
                tipoLicencia: { id: 0, nombre: '' },
                tipoLicenciaModalidad: { id: 0, nombre: '' },
                numeroDocumento: '',
                vigencia: unAnioDespues
            }];

            dispatch({ type: 'reset', getDefault: () => empleado });      
            console.log(empleado)
        };


        let timer1 = setTimeout(loadEmpleado, 100);
        return () => {
            clearTimeout(timer1)
        }
    }, [seguridad, api]);



    const actualizar = (value, propertyName) => {
        if (propertyName === "rfc") {            
            const nuevo = { ...entity?.datosGenerales };
            nuevo[propertyName] = value;
            onChange(nuevo, 'datosGenerales');
        }
        else if(propertyName === "unidadNegocio"){
            const nuevo = { ...entity?.asignacion };
            nuevo[propertyName] = value;
            onChange(nuevo, 'asignacion');
        }
        else if (propertyName === "licencia" || propertyName === "vigencia" || propertyName === "tipoLicencia" || propertyName === "categoriaLicencia" || propertyName === "tipoLicenciaModalidad") {
            
            // Crear una NUEVA licencia con los valores actualizados
            const licenciaActual = entity.licencias?.[0] ? { ...entity.licencias[0] } : {};
            
            if (propertyName === "licencia") {
                licenciaActual.numeroDocumento = value;
            } else if (propertyName === "vigencia") {
                licenciaActual.vigencia = value;
            } else {
                // Para tipoLicencia, categoriaLicencia, modalidadLicencia
                licenciaActual[propertyName] = value;
            }            
            // Crear un NUEVO array de licencias
            const nuevasLicencias = [licenciaActual];
            
            onChange(nuevasLicencias, 'licencias');
        }
        else {
            const nuevo = { ...entity?.datosGenerales };
            nuevo[propertyName] = value;
            console.log(`🟢 Nuevos datosGenerales:`, nuevo);
            onChange(nuevo, 'datosGenerales');
        }
    };

    const onChange = (value, name) => {
        dispatch({ type: 'update', value, name });
    };

    // FUNCIÓN DE VALIDACIÓN CON YUP
    const validarFormulario = async () => {
        try {
            // Limpiar errores anteriores
            setValidationErrors({});
            // Validar con Yup
            await permValidacionEsquema.alta.validate(entity, { abortEarly: false });
            return true;
        } catch (error) {
            if (error.name === 'ValidationError') {
                const nuevosErrores = {};
                error.inner.forEach(err => {
                    // Extraer el nombre del campo del path
                    const fieldName = err.path.split('.').pop();
                    nuevosErrores[fieldName] = err.message;
                });
                setValidationErrors(nuevosErrores);
                
                // Mostrar el primer error
                const primerError = error.inner[0];
                alerts.aviso(primerError.message || 'Por favor completa todos los campos requeridos');
            }
            return false;
        }
    };

    const guardarNuevo = async () => {
        try {
            // Validar RFC
            const rfcResponse = validateRfc(entity.datosGenerales?.rfc);
            if (!rfcResponse.isValid) {
                alerts.aviso('RFC con formato inválido');
                return;
            }
            if(!entity.asignacion?.unidadNegocio || entity.asignacion?.unidadNegocio.id <= 0){
                alerts.aviso('La unidad de negocio es requerida');
                return;
            }

            // Validar con Yup
            const esValido = await validarFormulario();
            if (!esValido) {
                return;
            }


            const licencia = entity.licencias?.[0];
            const erroresLicencia = {};

            if (!licencia) {
                alerts.aviso('La información de licencia es requerida');
                return;
            }           
            if (!licencia.tipoLicencia || !licencia.tipoLicencia.id || licencia.tipoLicencia.id <= 0) {
                erroresLicencia.tipoLicencia = 'El tipo de licencia es requerido';
            }
            if (!licencia.categoriaLicencia || !licencia.categoriaLicencia.id || licencia.categoriaLicencia.id <= 0) {
                erroresLicencia.categoriaLicencia = 'La categoría de licencia es requerida';
            }
            if (!licencia.tipoLicenciaModalidad || !licencia.tipoLicenciaModalidad.id || licencia.tipoLicenciaModalidad.id <= 0) {
                erroresLicencia.tipoLicenciaModalidad = 'La modalidad de licencia es requerida';
            }
            // Si hay errores en licencia, mostrarlos
            if (Object.keys(erroresLicencia).length > 0) {
                setValidationErrors(prev => ({
                    ...prev,
                    licencias: [erroresLicencia]
                }));
                
                // Mostrar el primer error de licencia
                const primerErrorLicencia = Object.values(erroresLicencia)[0];
                alerts.aviso(primerErrorLicencia);
                return;
            }

            //Si pasa todas las validaciones, guardar
            console.log("Guardando entity:", entity);
            // Si pasa todas las validaciones, guardar
            await api.guardar(entity);
            alerts.aviso('Permisionario guardado correctamente');
            close();
            onSave();

        } catch (error) {
            console.error('Error al guardar nuevo usuario permisionario:', error);
            alerts.aviso('Error al guardar el permisionario');
        }
    };

    // Combinar errores de formReducer con errores de validación Yup
    const erroresCombinados = {
        ...errors,
        datosGenerales: {
            ...errors?.datosGenerales,
            ...validationErrors
        }
    };

    return (
        <div className="p-3">
            <h4>Agregar Permisionario</h4>
            
            <div className="form-row">
                <FieldTextBox 
                    required 
                    name="nombre" 
                    label="Nombre(s)" 
                    colMd={12}
                    value={entity.datosGenerales?.nombre} 
                    onChange={actualizar} 
                    errors={erroresCombinados}
                />

                <FieldTextBox 
                    required 
                    name="apellidoPaterno" 
                    label="Apellido Paterno" 
                    colMd={6}
                    value={entity.datosGenerales?.apellidoPaterno} 
                    onChange={actualizar} 
                    errors={erroresCombinados}
                />

                <FieldTextBox 
                    name="apellidoMaterno" 
                    label="Apellido Materno" 
                    colMd={6}
                    value={entity.datosGenerales?.apellidoMaterno} 
                    onChange={actualizar} 
                    errors={erroresCombinados}
                />

                <FieldInputNumeroRfc 
                    required 
                    name="rfc" 
                    label="RFC" 
                    colMd={6}
                    value={entity.datosGenerales?.rfc} 
                    onChange={actualizar} 
                    errors={erroresCombinados}
                />

                <FieldDropDown name="unidadNegocio" label="Unidad de Negocio" colMd={3} source="unidadesNegocio" errors={erroresCombinados} filter className="dropdown-bottom"
                               value={entity.asignacion?.unidadNegocio}  onChange={actualizar} />                

                <FieldInputNumeroPhone 
                    name="telefonoABC" 
                    label="Teléfono Empresa" 
                    colMd={12}
                    value={entity.datosGenerales?.telefonoABC} 
                    onChange={actualizar} 
                    errors={erroresCombinados}
                />

                <FieldInputNumeroPhone 
                    name="telefonoPersonal" 
                    label="Teléfono Personal" 
                    colMd={12}
                    value={entity.datosGenerales?.telefonoPersonal} 
                    onChange={actualizar} 
                    errors={erroresCombinados}
                />

                <h5 className="col-12">*Licencia</h5>
                <FieldTextBox 
                    name="licencia" 
                    label="Num. Licencia" 
                    colMd={6}
                    value={entity.licencias[0]?.numeroDocumento} 
                    onChange={actualizar} 
                    errors={erroresCombinados}
                />

                <FieldCalendar
                    name="vigencia"
                    label="Vigencia Licencia"
                    colMd={4}
                    value={entity.licencias[0]?.vigencia}
                    className="small large-padding-bottom"
                    showButtonBar={false}
                    errors={erroresCombinados?.licencias?.[0]}
                    onChange={actualizar} 
                />
                <FieldDropDown
                    name="tipoLicencia"
                    label="Tipo Licencia"
                    colMd={4}
                    source="tiposLicencia"
                    filter
                    errors={erroresCombinados?.licencias?.[0]}
                    value={entity.licencias[0]?.tipoLicencia}
                    onChange={actualizar} 
                />

                <FieldDropDown
                    name="categoriaLicencia"
                    label="Categoria Licencia"
                    colMd={4}
                    source="categoriasLicencia"
                    filter
                    errors={erroresCombinados?.licencias?.[0]}
                    value={entity.licencias[0]?.categoriaLicencia}
                    onChange={actualizar} 
                />

                <FieldDropDown
                    name="tipoLicenciaModalidad"
                    label="Modalidad Licencia"
                    colMd={5}
                    source="tiposLicenciaModalidad"
                    filter
                    errors={erroresCombinados?.licencias?.[0]}
                    value={entity.licencias[0]?.tipoLicenciaModalidad}
                    onChange={actualizar} 
                />
                

            </div>

            <div className="form-footer d-flex justify-content-end gap-2 mt-3">
                <Button 
                    label="Cancelar" 
                    className="p-button-secondary" 
                    type="button"
                    onClick={close} 
                />

                <Button 
                    label="Guardar" 
                    className="p-button-primary" 
                    type="button"
                    onClick={guardarNuevo} 
                />                
            </div>
        </div>
    );
};

export default AgendaNuevo;